import { render, staticRenderFns } from "./quesPreview.vue?vue&type=template&id=1351044e&"
import script from "./quesPreview.vue?vue&type=script&lang=js&"
export * from "./quesPreview.vue?vue&type=script&lang=js&"
import style0 from "./quesPreview.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports